import Glide from '@glidejs/glide'

if (document.querySelectorAll('.glide').length) {
    new Glide('.glide', {
        'type': 'carousel',
        'gap': 0,
        'arrows': true
    }).mount()
}
